<template>
  <v-btn @click="dump">
    {{ $t("message.dump.get_support_information") }}
  </v-btn>
</template>

<script>
import { saveAs } from "file-saver";
import jszip from "jszip";
import sanitize_filename from "sanitize-filename";

export default {
  name: 'dump_store',
  data: function(){
    return {
      module_id: "6A",
      dummy: {
        "a": "aaa"
      }
    };
  },
  methods: {
    dump() {
      // ファイル名
      var date = new Date();
      var date_str = ('' + date.getFullYear()).slice(-2)
                   + ('0' + (date.getMonth() + 1)).slice(-2)
                   + ('0' + date.getDate()).slice(-2)
                   + ('0' + date.getHours()).slice(-2)
                   + ('0' + date.getMinutes()).slice(-2);
      var fileName = this.$store.getters.domain + "_" + date_str;
      // store情報の収集
      var result = {
        date: Math.floor(new Date() / 1000),
        navigator: {}
      };
      for(var key in this.$store.state){
        if(["auth", "fields", "langs"].indexOf(key) >= 0){
          continue;
        }else if(key === "web_socket"){
          result[key] = {};
          for(var namespace in this.$store.state[key]){
            result[key][namespace] = this.$store.state[key][namespace].id;
          }
        }else{
          result[key] = this.$store.state[key];
        }
      }
      for(var key in navigator){
        result.navigator[key] = navigator[key];
      }
      // zip作成 & ダウンロード
      var zip = new jszip();
      zip.file(fileName + ".json", JSON.stringify(result));
      zip.generateAsync({type:'blob'})
        .then(function(blob){
          saveAs(blob, sanitize_filename(fileName + ".zip"));
        });
    }
  }
}
</script>
